/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import Colors, { colorClassNames } from '../../../styles/Colors';
import CategorySelect from './CategorySelect';

import List from '../../../components/List';
import { PhraseData } from '../../../../utilities/localizedUtil';
import { ShareCardItemGroup } from '../../../../models/ShareCardModel';
import { Card } from '../../../../bphComponents/bundle';
import FlexRow from '../../../components/FlexRow';

interface Props {
  group: ShareCardItemGroup;

  shareCardItemProps?: any;
  shareCardColorModel: any;
  icon?(props): React.ReactFragment;
  titlePhraseData: PhraseData;
  isExpanded: boolean;

  toggleExpand(e): void;
  children: React.ReactFragment;
  showTotals: boolean;
  toggleAll(): void;
}

export const ShareCardCategory = (props: Props) => {
  const { titlePhraseData, shareCardColorModel, toggleExpand, children, icon, group, isExpanded, showTotals, toggleAll, shareCardItemProps } = props;

  let excluded = null;
  let required = null;
  let countIncluded = null;
  let countTotal = null;

  if (group) {
    excluded = group.isExcluded();
    required = group.isRequired();
    countIncluded = group.countIncluded();
    countTotal = group.countTotal();
  } else {
    excluded = shareCardItemProps.isExcluded;
    required = shareCardItemProps.isRequired;
    countIncluded = shareCardItemProps.countIncluded;
    countTotal = shareCardItemProps.countTotal;
  }

  const toggleSelectAll = async (e) => {
    e.stopPropagation();
    if (!isExpanded) {
      await toggleExpand(e);
    }
    toggleAll();
  };

  return (
    <List hasBorder paddingSize="default">
      <Card.CardSection
        hasBottomBorder
        style={{
          backgroundColor: shareCardColorModel.cssColor(0.05),
        }}
      >
        <FlexRow style={{ padding: '18px 16px', cursor: 'pointer' }} onClick={excluded ? null : toggleExpand}>
          <div
            className={cx('fill-color-transparent', {
              [colorClassNames.font('input-inactive')]: excluded,
            })}
          >
            <div>
              <div>
                {icon && icon({ color: excluded ? 'inactive' : 'dark-neutral', size: '24' })}
              </div>
              <div className="font-subhead">
                <FormattedMessage {...titlePhraseData} />
              </div>
            </div>
          </div>

          {!excluded &&
            <div onClick={required ? null : toggleSelectAll}>
              <CategorySelect
                selectedTotal={showTotals ? countIncluded : null}
                allTotal={showTotals ? countTotal : null}
                color={required ? Colors.middleGray : shareCardColorModel.cssColor()}
                showTotals={showTotals}
                zeroSelected={required}
              />
            </div>
          }
        </FlexRow>
      </Card.CardSection>

      {!excluded && isExpanded && children}
    </List>
  );
};
